import React from 'react';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import Chip from '@mui/material/Chip';
import Tooltip from '@mui/material/Tooltip';
import Grid from '@mui/material/Unstable_Grid2';
import Card from '@mui/material/Card';
import { Icon } from '@iconify/react';

import { summarizeWeeklySchedule, getScheduleTypeColor, getScheduleTypeIcon } from '../utils';

export default function TimetablesPanel({ timetables, onNew, onEdit, onDelete }) {
  return (
    <Accordion sx={{ mb: 3 }} defaultExpanded={false}>
      <AccordionSummary expandIcon={<Icon icon="mdi:chevron-down" width={22} />}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Icon icon="mdi:calendar-multiple" width={20} />
          <Box>
            <Typography variant="subtitle1">Manage Timetables</Typography>
            <Typography variant="caption" color="text.secondary">
              {timetables.length} available · 4 built-in presets always ready to use, or design your own
            </Typography>
          </Box>
        </Box>
      </AccordionSummary>
      <AccordionDetails>
        <Box sx={{ display: 'flex', justifyContent: 'flex-end', mb: 2 }}>
          <Button size="small" variant="contained" onClick={onNew} startIcon={<Icon icon="mdi:plus" />}>
            New Custom Timetable
          </Button>
        </Box>

        <Grid container spacing={1.5}>
          {timetables.map((tt) => {
            const color = getScheduleTypeColor(tt.scheduleType);
            return (
              <Grid key={tt.id} xs={12} sm={6}>
                <Card variant="outlined" sx={{ p: 1.5, borderLeft: '4px solid', borderLeftColor: `${color}.main` }}>
                  <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', gap: 1 }}>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
                      <Box sx={{ display: 'flex', color: `${color}.main` }}>
                        <Icon icon={getScheduleTypeIcon(tt.scheduleType)} width={18} />
                      </Box>
                      <Box sx={{ minWidth: 0 }}>
                        <Typography variant="body2" fontWeight="medium" noWrap>
                          {tt.name}
                        </Typography>
                        <Typography variant="caption" color="text.secondary" noWrap>
                          {summarizeWeeklySchedule(tt.weeklySchedule)}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ display: 'flex', gap: 0.25, flexShrink: 0 }}>
                      {tt.isPreset ? (
                        <Tooltip title="Built-in preset — always available">
                          <Chip size="small" label="Preset" variant="outlined" />
                        </Tooltip>
                      ) : (
                        <>
                          <IconButton size="small" onClick={() => onEdit(tt)}>
                            <Icon icon="mdi:pencil-outline" width={16} />
                          </IconButton>
                          <IconButton size="small" color="error" onClick={() => onDelete(tt.id)}>
                            <Icon icon="mdi:delete-outline" width={16} />
                          </IconButton>
                        </>
                      )}
                    </Box>
                  </Box>
                </Card>
              </Grid>
            );
          })}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}
